// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__7f16G","spin":"Spinner_spin__xyVYo","inner__spinner":"Spinner_inner__spinner__2Zqc3"};